module.exports = __webpack_public_path__ + "img/zipcar.03108a5a.png";